const UPDATE = 'modules/manageMarketingCheckboxStatus/UPDATE';

const reducer = (state = false, action) => {
  switch (action.types) {
    case UPDATE:
      return action.checked;
    default:
      return state;
  }
};

const updateMarketingCheckboxStatus = checked => {
  return {
    checked,
    type: UPDATE,
  };
};

export { reducer as default, updateMarketingCheckboxStatus };
